export default "__VITE_ASSET__CtUCDG94__"